export class EventEditModel {
    public id: number;
    public parentId: string;
    public categoryId: number;
    public title: string;
    public date: string;
    public description: string;
    public isPremium: boolean;
    public isSpecial: boolean;

    public photographerId: string;
    public priceForSmall: string;
    public priceForMedium: string;
    public priceForLarge: string;

    public imageCount: number;

    constructor() {
        this.parentId = '';
    }
}
